

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import AvatarGoal, { KVAvatarGoalConfiguration } from '@/embed/widget/components/AvatarGoal.vue'
import { KVConfiguration, KVEventBus } from '@/embed/widget/App.vue'
import { WidgetType } from '@/api/types'
import { WidgetAction } from '@/embed/widget/actions'
import BlondCircle from '@/components/avatar/BlondCircle.vue'
import BlondEntering from '@/components/avatar/BlondEntering.vue'
import BlondFirstOpen from '@/components/avatar/BlondFirstOpen.vue'
import BlondMenuOpen from '@/components/avatar/BlondMenuOpen.vue'
import BlondWaiting1 from '@/components/avatar/BlondWaiting1.vue'
import BlondWaiting2 from '@/components/avatar/BlondWaiting2.vue'
import BlondWaiting3 from '@/components/avatar/BlondWaiting3.vue'
import BrunetteCircle from '@/components/avatar/BrunetteCircle.vue'
import BrunetteEntering from '@/components/avatar/BrunetteEntering.vue'
import BrunetteFirstOpen from '@/components/avatar/BrunetteFirstOpen.vue'
import BrunetteMenuOpen from '@/components/avatar/BrunetteMenuOpen.vue'
import BrunetteWaiting1 from '@/components/avatar/BrunetteWaiting1.vue'
import BrunetteWaiting2 from '@/components/avatar/BrunetteWaiting2.vue'
import BrunetteWaiting3 from '@/components/avatar/BrunetteWaiting3.vue'
import SylvanaCircle from '@/components/avatar/SylvanaCircle.vue'
import SylvanaEntering from '@/components/avatar/SylvanaEntering.vue'
import SylvanaFirstOpen from '@/components/avatar/SylvanaFirstOpen.vue'
import SylvanaMenuOpen from '@/components/avatar/SylvanaMenuOpen.vue'
import SylvanaWaiting1 from '@/components/avatar/SylvanaWaiting1.vue'
import SylvanaWaiting2 from '@/components/avatar/SylvanaWaiting2.vue'
import SylvanaWaiting3 from '@/components/avatar/SylvanaWaiting3.vue'

export enum CharacterState {
    HIDDEN,
    ENTERING,
    FIRST_ENTER,
    MENU_SHOWN,
    WAITING,
}

export enum WaitingState {
    RELAXED,
    ALERTED,
    ON_PHONE,
}

export interface AvatarConfiguration {
    goals: KVAvatarGoalConfiguration[]
    menuColor: string
    menuTextColor: string
}

@Component({
    components: {
        AvatarGoal,
        BlondCircle,
        BlondEntering,
        BlondFirstOpen,
        BlondMenuOpen,
        BlondWaiting1,
        BlondWaiting2,
        BlondWaiting3,
        BrunetteCircle,
        BrunetteEntering,
        BrunetteFirstOpen,
        BrunetteMenuOpen,
        BrunetteWaiting1,
        BrunetteWaiting2,
        BrunetteWaiting3,
        SylvanaCircle,
        SylvanaEntering,
        SylvanaFirstOpen,
        SylvanaMenuOpen,
        SylvanaWaiting1,
        SylvanaWaiting2,
        SylvanaWaiting3,
    },
})
export default class Avatar extends Vue {
    @Prop({required: true}) config!: KVConfiguration
    characterState: number = CharacterState.HIDDEN
    characterCycle: any = null
    waitingState: number = WaitingState.RELAXED
    waitingCycleInterval: number = 10000
    waitingCycle: any = null
    waitingAnimateBounce: boolean = false
    waitingBounceCycle: any = null

    mounted() {
        KVEventBus.$on(WidgetAction.WIDGET_CLOSE, this.hide)
        KVEventBus.$on(WidgetAction.WIDGET_OPEN, this.show)

        setTimeout(() => {
            this.characterState = CharacterState.ENTERING
        }, 500)
    }

    @Watch('characterState')
    handlePopup(): void {
        if (this.characterState !== CharacterState.ENTERING) {
            return
        }

        clearTimeout(this.characterCycle)

        this.characterCycle = setTimeout(() => {
            this.characterState = this.firstEnter ? CharacterState.FIRST_ENTER : CharacterState.WAITING
        }, 1000)
    }

    @Watch('characterState')
    handleFirstEnter(): void {
        if (this.characterState !== CharacterState.FIRST_ENTER) {
            return
        }

        setTimeout(this.animate, 1000)

        const expire = new Date()
        expire.setTime((new Date()).getTime() + 3600000 * 24 * 14)
        document.cookie = 'kv-widget-first-open=true; SameSite = none; Secure; expires=' + expire.toUTCString()
    }

    @Watch('characterState')
    handleWaiting(): void {
        if (this.characterState !== CharacterState.WAITING) {
            return
        }

        clearTimeout(this.waitingCycle)

        this.waitingCycle = setTimeout(() => {
            this.cycleWaitingState()
        }, this.waitingCycleInterval)
    }

    @Watch('characterState')
    handleNotWaiting(): void {
        if (this.characterState === CharacterState.WAITING) {
            return
        }

        clearTimeout(this.waitingBounceCycle)
        clearTimeout(this.waitingCycle)
        this.waitingBounceCycle = null
        this.waitingCycle = null
    }

    @Watch('waitingState')
    handleWaitingState(): void {
        clearTimeout(this.waitingCycle)

        this.waitingCycle = setTimeout(() => {
            this.cycleWaitingState()
        }, this.waitingCycleInterval)
    }

    cycleWaitingState(): void {
        this.waitingAnimateBounce = true

        /** The time is chosen on ammount of times we want the MoveUpDown css animation to be shown */
        this.waitingBounceCycle = setTimeout(() => {
            this.waitingAnimateBounce = false
        }, 2000)

        switch (this.waitingState) {
            case WaitingState.RELAXED:
                this.waitingState = WaitingState.ALERTED
                break

            case WaitingState.ALERTED:
                this.waitingState = WaitingState.ON_PHONE
                break

            case WaitingState.ON_PHONE:
                this.waitingState = WaitingState.RELAXED
                break
        }
    }

    animate(): void {
        const buttons = document.querySelectorAll('.js-kv-button')
        let interval = 1000

        /** animationTime is chosen by the total length of the css animation */
        const animationTime = 2000

        /** We need to determine how long the animation will take place to change state again */
        const totalSequenceTime = (interval) * this.config.avatar.goals.length + animationTime

        buttons.forEach(el => {
            setTimeout(() => {
                el.classList.toggle('kv-avatar-button-list__button--show')
            }, interval)

            setTimeout(() => {
                el.classList.toggle('kv-avatar-button-list__button--show')
            }, animationTime + interval)

            interval += 500
        })

        this.characterCycle = setTimeout(() => {
            this.characterState = CharacterState.WAITING
        }, totalSequenceTime)
    }

    toggleShow(): void {
        if (this.characterState === CharacterState.MENU_SHOWN || this.characterState === CharacterState.FIRST_ENTER) {
            this.characterState = CharacterState.WAITING
        } else {
            this.characterState = CharacterState.MENU_SHOWN
        }
    }

    hide(): void {
        this.characterState = CharacterState.WAITING
    }

    show(): void {
        this.characterState = CharacterState.MENU_SHOWN
    }

    /** implemented so we can use this inside the template */
    get characterStateEnum(): typeof CharacterState {
        return CharacterState
    }

    /** implemented so we can use this inside the template */
    get waitingStateEnum(): typeof WaitingState {
        return WaitingState
    }

    get firstEnter(): boolean {
        return !document.cookie.split(';').some(item => {
            return item.trim().indexOf('kv-widget-first-open=') === 0
        })
    }

    get characterStateClass(): object {
        return {
            'kv-avatar-state': true,
            'kv-avatar-state--hidden': this.characterState === CharacterState.HIDDEN,
            'kv-avatar-state--bounce': this.waitingAnimateBounce,
        }
    }

    get componentClass(): object {
        return {
            'kv-avatar': true,
        }
    }

    get buttonListClass(): object {
        return {
            'kv-avatar-button-list': true,
            'kv-avatar-button-list--first-enter': this.characterState === CharacterState.FIRST_ENTER,
            'kv-avatar-button-list--show-menu': this.characterState === CharacterState.MENU_SHOWN,
        }
    }

    get cssVars(): object {
        if (!this.config) {
            return {}
        }

        return {
            '--children': this.config.avatar.goals.length,
            '--brand-color': this.config.avatar.menuColor,
            '--text-color': this.config.avatar.menuTextColor,
        }
    }

    get goals(): KVAvatarGoalConfiguration[] {
        return this.config ? this.config.avatar.goals : []
    }

    get showComponent(): boolean {
        return this.config ? this.config.type === WidgetType.AVATAR : false
    }

    get avatarType(): string {
        const types: string[] = ['brunette', 'blond', 'sylvana']

        return types[this.config.avatarStyle]
    }
}
